import { convertContentfulRichTextToPlainText } from '@telialt/common-rich-text-content/src/utils';
import { isSSR } from '@telialt/utils/src/helpers';
import { TeliaSegment } from '@telialt/utils/src/segment';
import { getBPId, getIsUserAuthorized } from '@telialt/utils/src/SSO/utils';

import { TRACKER_CLIENT_ID_VALUE } from './constants';
import { LeadFormData, LeadSubmitData } from './model';

export const mapLeadFormDataToSubmitData = (segment: TeliaSegment, leadFormData: LeadFormData): LeadSubmitData => {
    const sourceUrl = !isSSR() ? window.location.href : '';
    const legalText = leadFormData.legalText?.fields.description
        ? convertContentfulRichTextToPlainText(leadFormData.legalText.fields.description)
        : undefined;
    const businessPartnerId = getIsUserAuthorized() ? getBPId() : undefined;

    return {
        p_tracker_client_id: TRACKER_CLIENT_ID_VALUE,
        p_segment: segment,
        p_source_url: sourceUrl,
        p_legal_text: legalText,
        p_business_partner_id: businessPartnerId,
        p_common_name: leadFormData.nameSurname,
        p_b2b_code: leadFormData.companyCodeName,
        p_telephone_number: leadFormData.phoneNumber,
        p_email: leadFormData.emailAddress,
        p_address_text: leadFormData.address,
        p_comment: leadFormData.comment,
        p_product_type: leadFormData.productType,
    };
};
